module.exports = __webpack_public_path__ + "095f4f4b5874486a564546c6ba1d83c5.pdf";